import { useTranslation } from 'react-i18next';
import { Typography } from '@web-chat-core/ui-kit';
import { useUserSettingsContext } from 'contexts';
import { useMicTest } from 'features/MicTest/hooks/useMicTest';
import { AudioBars } from 'ui/components/AudioBars/AudioBars';
import { StyledButton, StyledIcon, Description } from './view';

export const MicTestButton = () => {
    const { t } = useTranslation();

    const { permissions } = useUserSettingsContext();
    const isMicAvailable = permissions.audio;
    const { isRecording, isPlaying, handleClick } = useMicTest();

    const renderIcon = () => {
        if (isRecording) return <StyledIcon icon="icStop24" size={24} colorVariant="basic" />;
        if (isPlaying) return <AudioBars />;
        return <StyledIcon icon="icMicOn24" size={24} colorVariant="basic" />;
    };

    const renderLabel = () => {
        if (isRecording) return t('vks_microphone_stop_recording');
        if (isPlaying) return t('vks_microphone_playing');
        return t('vks_microphone_check_microphone');
    };

    const renderDescription = () => {
        if (!isMicAvailable) {
            return (
                <Typography variant="caption3" colorVariant="danger">
                    {t('vks_microphone_allow_microphone_access_in_settings')}
                </Typography>
            );
        }
        if (isRecording) {
            return (
                <Typography variant="caption3" colorVariant="colored">
                    {t('vks_microphone_speaking_recording_10s')}
                </Typography>
            );
        }
        if (isPlaying) {
            return (
                <Typography variant="caption3" colorVariant="second">
                    {t('vks_microphone_no_sound_select_other_device')}
                </Typography>
            );
        }
        return '';
    };

    return (
        <>
            <StyledButton key="check-mic-button" onClick={handleClick} disabled={!isMicAvailable}>
                {renderIcon()}
                <Typography variant="body3" colorVariant="base">
                    {renderLabel()}
                </Typography>
            </StyledButton>
            <Description>{renderDescription()}</Description>
        </>
    );
};

MicTestButton.displayName = 'MicTestButton';
